import { createUseStyles } from 'react-jss';
import { Theme } from '@wds/styles';
import rebrandFocusImg from '~static/images/rebrand_focus.png';
import { getSrc } from '~app/helpers/assetLoading';

const useStyle = createUseStyles((theme: Theme) => {
  const mediaQueryMinScreenSM = `@media (min-width: ${theme.breakpoints.sm}px)`;
  const mediaQueryMinScreenMD = `@media (min-width: ${theme.breakpoints.md}px)`;
  const mediaQueryMinScreenLG = `@media (min-width: ${theme.breakpoints.lg}px)`;
  const mediaQueryMinScreenXL = `@media (min-width: ${theme.breakpoints.xl}px)`;

  return {
    wrapper: {
      padding: '20px 20px 50px',
      maxWidth: '1400px',
      margin: '0 auto',
      overflowX: 'hidden',
      alignItems: 'center',
      [mediaQueryMinScreenSM]: {
        padding: '40px 60px 100px',
      },
      [mediaQueryMinScreenLG]: {
        padding: '80px 0 100px 100px',
        alignItems: 'flex-start',
      },
      [mediaQueryMinScreenXL]: {
        padding: '80px 0 100px 165px',
      },
    },

    image: {
      backgroundImage: `url(${getSrc(rebrandFocusImg)})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      position: 'relative',
      top: '70px',
      [mediaQueryMinScreenMD]: {
        width: '550px',
        height: '433px',
        left: '150px',
      },
      [mediaQueryMinScreenLG]: {
        width: '620px',
        height: '504px',
        left: '240px',
      },
    },

    ctaForm: {
      margin: '0 auto',
      maxWidth: '380px',
    },

    header: {
      // The wrench Typography used does not allow addition of a classname
      '& > section': {
        textAlign: 'center',
        width: '100%',
        maxWidth: '1020px',
        [mediaQueryMinScreenMD]: {
          fontSize: '34px',
        },
        [mediaQueryMinScreenLG]: {
          textAlign: 'left',
          fontSize: '50px',
        },
      },
      [mediaQueryMinScreenLG]: {
        width: '100%',
      },
    },

    subHeader: {
      fontWeight: theme.type.fontWeight.regular,
      width: '100%',
      maxWidth: '1020px',
      '&, & div': {
        textAlign: 'center',
      },
      [mediaQueryMinScreenLG]: {
        maxWidth: '480px',
        '&, & div': {
          textAlign: 'left',
        },
      },
    },

    bold: {
      fontWeight: 500,
    },
  };
});

export default useStyle;
